import { useEffect, useState } from "react";

import { IBoundProperties } from "./types";

export const usePropertyDraftText = ({ bindings, property }: { bindings?: IBoundProperties, property: string }) => {
    const [text, setText] = useState<string>()

    useEffect(() => {
        if (!bindings) return;

        const binding = bindings.getBinding(property);
        if (!binding || !binding.boundValue) return;

        switch (binding.type) {
            case "Const":
                return setText(`"${binding.boundValue}"`)
            case "Expression":
                return setText(`${binding.boundValue?.query}`)
            case "Field":
                return setText(`{${binding.boundValue}}`)
        }
    }, [bindings, property])

    return text
}
